<template>
  <bankChannelTab @getChannelType="handleGetChannelType" :bankType="2">
    <template>
      <div>
        <search-box
          :columns="searchBoxColumns"
          @search="search"
          @btnReset="handleReset"
        >
        </search-box>
        <el-button type="primary" size="small" @click="addAccount">
          新增子户
        </el-button>
        <QS-common-table
          :data="tableData"
          :columns="tableColumns"
          row-key="id"
          :pagination="paginationData"
          @change="paginationChange"
          v-loading="tableLoading"
        />
      </div>
      <enable-anddisable-dialog
        ref="enableAnddisableDialogRef"
        @update="handleRefreshList"
      />
      <pay-dialog ref="payDialogRef" />
      <add-child-account ref="addChildAccountRef" @submitSucc="handleUpdate" />
    </template>
  </bankChannelTab>
</template>

<script>
import bankChannelTab from '@/pages/finance/bankChannelTab'
// eslint-disable-next-line import/no-cycle
import addChildAccount from './components/addChildAccount.vue'
import config from './config'
// eslint-disable-next-line import/no-cycle
import { getSubAccountList, querySubAccountBalance, submitSubAccount } from '@/api/domain/finance'
import { cloneDeep } from 'lodash'
import EnableAnddisableDialog from './components/EnableAnddisableDialog.vue'
import PayDialog from './components/payDialog.vue'

export default {
  components: {
    bankChannelTab,
    EnableAnddisableDialog,
    PayDialog,
    addChildAccount,
  },
  data() {
    const { tableColumns, searchBoxColumns } = config.call(this)
    return {
      tableColumns,
      searchBoxColumns,
      tableData: [],
      formData: {
        // eslint-disable-next-line vue/no-unused-properties
        accountType: 2,
      },
      tableLoading: false,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
    }
  },
  methods: {
    // 更新tableData数据
    // eslint-disable-next-line vue/no-unused-properties
    updateTableData() {
      this.tableData = cloneDeep(this.tableData)
    },
    // eslint-disable-next-line vue/no-unused-properties
    handleSetRefresh(row) {
      row.accountBalance.loading = true
      querySubAccountBalance({
        accountId: row.accountId,
        channelType: this.formData.channelType,
      }).then(({ code, data }) => {
        if (code === 1) {
          row.accountBalance.availableAmount =
                            data.availableAmount
          row.accountBalance.frozenAmount = data.frozenAmount
        }
      }).finally(() => {
        row.accountBalance.loading = false
      })
    },
    // 更新列表
    handleUpdate() {
      this.getSubAccountListCb()
    },
    addAccount() {
      this.$refs.addChildAccountRef.open({
        channelType: this.formData.channelType,
      })
    },
    search(formdata) {
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.formData = { ...this.formData, ...formdata }
      this.getSubAccountListCb()
    },
    handleReset() {
      this.formData = {
        accountType: 2,
        channelType: this.formData.channelType,
      }
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.getSubAccountListCb()
    },
    // 分页
    paginationChange(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.getSubAccountListCb()
    },
    // 开户
    // eslint-disable-next-line vue/no-unused-properties
    async openAccount(row) {
      const { code, data, msg } = await submitSubAccount({
        accountId: row.accountId,
        accountType: 2,
      })

      if (code === 1) {
        if (data) {
          this.$message.success('开户成功')
          this.getSubAccountListCb()
        } else {
          this.$message.error(msg)
        }
      }
    },
    // 编辑&子户
    // eslint-disable-next-line vue/no-unused-properties
    editAccount(row) {
      row.isEdit = true
      row.channelType = ''
      this.$refs.addChildAccountRef.open(row)
    },
    // 启用/停用状态
    // eslint-disable-next-line vue/no-unused-properties
    handleState(row) {
      const confirmDialog = {
        type: row.state,
        merchantName: row.merchantName,
        show: true,
        loading: false,
        accountId: row.accountId,
      }
      this.$refs.enableAnddisableDialogRef.open(confirmDialog)
    },
    // 更新list列表
    handleRefreshList() {
      this.getSubAccountListCb()
    },
    // 充值
    // eslint-disable-next-line vue/no-unused-properties
    openPay(row) {
      this.$refs.payDialogRef.open(row)
    },
    // mode: bind, change
    // eslint-disable-next-line vue/no-unused-properties
    bindCardState(row, type, mode) {
      const formData = {
        accountId: row.accountId,
        merchantName: row.merchantName,
        licenceNo: row.licenceNo,
        mode,
      }
      this.$router.push({
        name: type,
        query: {
          data: JSON.stringify(formData),
        },
      })
    },
    handleGetChannelType(newValue) {
      this.formData.channelType = newValue
      this.tableColumns = this.tableColumns.filter((item) => {
        return item.name !== 'orgList' && item.name !== 'relationCompanys'
      })
      this.getSubAccountListCb()
    },
    async getSubAccountListCb() {
      const [err, _data] = await this.$to(
        getSubAccountList({
          ...this.formData,
          pageNum: this.paginationData.pageNum,
          pageSize: this.paginationData.pageSize,
        }),
      )
      if (err) return
      const { code, data } = _data
      if (code !== 1) return
      if (!data.items) data.items = []
      this.paginationData.total = data.totalNum
      this.tableData = data.items.map((item) => ({
        ...item,
        accountBalance: { loading: false, availableAmount: null, frozenAmount: null },
      }))
    },
  },
}
</script>
